import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedIncidentUpdatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDiffList,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface IncidentUpdatedEventProps {
  event: DiscriminatedIncidentUpdatedEvent;
}

export const IncidentUpdatedEvent: React.FC<IncidentUpdatedEventProps> = ({
  event,
}) => {
  const { incident, diff } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-orange-100">
          <PencilIcon className="h-4 w-4 text-orange-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {incident?.date_of_loss && (
        <ActivityTitle>
          {new Date(incident.date_of_loss).toLocaleDateString()}
        </ActivityTitle>
      )}
      {diff && <ActivityDiffList diff={diff} defaultExpanded={false} />}
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Incident Updated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
